export const reactAppClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
